import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { MediaData } from "../../../models/admin/media.model";


@Injectable({
  providedIn: 'root'
})
export class MediaService extends HttpService<any, MediaData> {
  private mediaListSubject = new BehaviorSubject<MediaData | null>(null);
  readonly mediaList$ = this.mediaListSubject.asObservable();

  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string
  ) {
    super(httpClient, apiUrl, apiVersion, 'upload');
  }

  getAllMedia(page = 1, limit = 10): Observable<MediaData | null> {
    return this.getPagedGeneral('upload', page, limit).pipe(
      tap(response => this.mediaListSubject.next(response)),
      catchError(() => of(null))
    );
  }


  deleteMediaByID(id: number | string | Array<number | string>): Observable<any> {
    return this.deleteByIds('upload', id).pipe(
      tap(() => {
        const currentList = this.mediaListSubject.value;
        if (currentList && Array.isArray(currentList.records)) {
          const idsToDelete = Array.isArray(id) ? id : [id];
          const updatedData = currentList.records.filter(
            item => !idsToDelete.includes(item.id)
          );
          this.mediaListSubject.next({ ...currentList, records: updatedData });
        }
      }),
      catchError(error => {
        console.error('Error deleting media:', error);
        return of(null);
      })
    );
  }


    getFilteredMedia(entity: any): Observable<MediaData | null> {
      return this.filterAllActionPaged(entity, '').pipe(
        tap((response) => this.mediaListSubject.next(response)),
        catchError(() => of(null))
      );
    }
 

}
